/**
 * The idempotency key for one submission. Minted when a cart or a selection is
 * started and sent with every attempt to place it, so a double tap, a retry
 * after a timeout, or a reload mid-submit all reach the server with the same
 * key — and the server returns the request it already created.
 *
 * Document-id safe (the server uses the key as the request id): hex only, no
 * dashes, well under the length limit.
 */
export function newIdempotencyKey(): string {
  const uuid =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `${Date.now().toString(16)}${Math.random().toString(16).slice(2)}${Math.random().toString(16).slice(2)}`;
  return `req_${uuid.replace(/-/g, '').slice(0, 32)}`;
}
